import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { GIFT_PRODUCT_INQUIRY_LIST_QUERY } from "../Queries";
import useInput from "../../../../Hooks/useInput";
import Presenter from "./Presenter";
import qs from "qs";

export default withRouter(({ history, match, location }) => {
  const queryString = qs.parse(location.search.substr(1));
  var page = queryString.page ? queryString.page : 1;
  const giftProduct = queryString.giftProduct ? queryString.giftProduct : "";
  var keyword = queryString.keyword ? queryString.keyword : "";
  const keywordInput = useInput(keyword);
  const blockSize = 5;
  const first = 15;
  const skip = first * (page - 1);
  const baseUrl =
    "?" +
    (keywordInput.value ? "keyword=" + keywordInput.value + "&" : "") +
    (giftProduct ? "giftProduct=" + giftProduct + "&" : "");

  const { data, loading } = useQuery(GIFT_PRODUCT_INQUIRY_LIST_QUERY, {
    variables: { giftProduct, keyword, skip, first },
  });

  const handleSearch = (e) => {
    e.preventDefault();
    history.push(`/giftProductInquiries${baseUrl}page=1`);
  };

  return (
    <>
      <Presenter
        history={history}
        match={match}
        location={location}
        page={page}
        giftProduct={giftProduct}
        keyword={keyword}
        keywordInput={keywordInput}
        blockSize={blockSize}
        first={first}
        skip={skip}
        data={data}
        loading={loading}
        baseUrl={baseUrl}
        handleSearch={handleSearch}
      ></Presenter>
    </>
  );
});
